/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
    Response
} from '../../../../../_metronic/helpers'

import { getDLMROIs } from '../_requests'
import { DLMROIListItem } from '../_models'
import { useDLMROIQueryRequest } from './DLMROIQueryRequestProvider'
import { useAuth } from '../../../auth'


const DLMROIQueryResponseContext = createResponseContext<DLMROIListItem>(initialQueryResponse)
const DLMROIQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useDLMROIQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
    

    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['DLMROI-LIST'],        
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else { 
                return getDLMROIs();
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <DLMROIQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </DLMROIQueryResponseContext.Provider>
    )
}

const useDLMROIQueryResponse = () => useContext(DLMROIQueryResponseContext)

const useDLMROIQueryResponseData = () => {
    const {response} = useDLMROIQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useDLMROIQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useDLMROIQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useDLMROIQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMROIQueryResponse()
  return isLoading
}

export {
    DLMROIQueryResponseProvider,
    useDLMROIQueryResponse,
    useDLMROIQueryResponseData,
    useDLMROIQueryResponsePagination,
    useDLMROIQueryResponseLoading,
}


export type DLMROIQueryResponse = Response<Array<DLMROIListItem>>